export default "__VITE_ASSET__7ef22918__"